module.exports = __webpack_public_path__ + "img/logo.dc0057cb.svg";